import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = {
  key: 0,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#companyModal",
  style: {"background-color":"#EB9355"}
}
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_23 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_24 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_26 = { class: "dropdown" }
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_32 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_33 = { class: "fw-bold" }
const _hoisted_34 = { class: "fw-bold" }
const _hoisted_35 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_36 = { class: "fw-bold" }
const _hoisted_37 = { class: "fw-bold" }
const _hoisted_38 = { class: "mt-15 mt-md-0" }
const _hoisted_39 = { class: "pagination mb-0" }
const _hoisted_40 = {
  key: 0,
  class: "page-item"
}
const _hoisted_41 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 1,
  class: "page-item"
}
const _hoisted_44 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_45 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_46 = { class: "modal-content" }
const _hoisted_47 = { class: "modal-header" }
const _hoisted_48 = { class: "modal-title fs-5" }
const _hoisted_49 = { class: "modal-body" }
const _hoisted_50 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_51 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_52 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_53 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_54 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_58 = ["placeholder"]
const _hoisted_59 = { class: "invalid-feedback" }
const _hoisted_60 = { class: "col-md-6" }
const _hoisted_61 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_62 = ["placeholder"]
const _hoisted_63 = { class: "invalid-feedback" }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_67 = ["placeholder"]
const _hoisted_68 = { class: "invalid-feedback" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_71 = ["placeholder"]
const _hoisted_72 = { class: "invalid-feedback" }
const _hoisted_73 = { class: "modal-footer" }
const _hoisted_74 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}

import {ref, onMounted,reactive,inject } from "vue";
import axios from 'axios';
import { useI18n } from "vue-i18n";
import router from '../../router/index'
import { checkSessionValidate } from "@/utils/function";
import { useTableFilter } from "../../utils/UseTablefilter";
import {current_permissions} from '../../utils/permission';
import { useRouter } from 'vue-router';
import * as yup from 'yup';

declare interface Country {
  id : string,
  code: string,
  name: string,
  indicative: string,    
  currency: string,
  countryCode: string,
  created_at: string,
  status:string
  }
 
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CountryContent',
  setup(__props) {

const backApi=inject('back');

const { t } = useI18n();


let token: string|null = localStorage.getItem('login_token');

const errors = ref('');  
  const success = ref('');
  const errorsBis = {'name':'','code':'','indicative':'','currency':''};
  const pageLoad = ref(false);

  const formValues = reactive({
    code: "",  
    indicative: "",  
    name: "",  
    currency: ""
  });

  const phoneRegExp = /^((\\+[0-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  //const currencyRegExp = /^((\\+[A-Z]{3}[ \\-]*))?$/;
  const codeRegExp = /^([A-Z]{2})$/;
  const currencyRegExp = /^([A-Z]{3})$/;
  const indicativeRegExp = /^([0-9]{3})$/;
  const schema = yup.object({    
      code: yup.string().required('Le code pays est requis').matches(codeRegExp,"Veuillez saisir un code pays valide").test('len', "Le code pays doit faire 2 caractères", val => val.length === 2),  
      name: yup.string().required('Le nom du pays est requis'),   
      currency: yup.string().required('La dévise est requise').matches(currencyRegExp,"Veuillez saisir une dévise valide").test('len', "La dévise doit faire 3 caractères", val => val.length === 3),  
      indicative: yup.string().required('L\'indicatif est requis').matches(indicativeRegExp,"Veuillez saisir un indicatif valide").test('len', "L'indicatif doit faire 3 chiffres'", val => val.length === 3),     
  });


const countries =ref(new Array<Country>());
  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

const {
  searchQuery,
  paginatedData: paginatedCountries,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  countries,
  [
    (c: any) => c.code,
    (c: any) => c.countryCode,
    (c: any) => c.name,
    (c: any) => c.indicative,
    (c: any) => c.currency,
    (c: any) => c.status,
  ],
  15
);
const getCountries = (arg=1) =>{
    // +arg
    axios.get(backApi+'/secure/countries/',{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        countries.value = response.data;  //.data.countries            
        
        // total.value=parseInt(response.data.pagination.total);
        // page.value=parseInt(response.data.pagination.page);
        // pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        // currentPage.value=parseInt(response.data.pagination.currentPage);
        // numPages.value=parseInt(response.data.pagination.numPages);

        // total.value=10;
        // page.value=1;
        // pagesLeft.value=0;
        // currentPage.value=1;
        // numPages.value=1;
        
        // alert(total.value)
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const changeStatus =(status,code)=>{
  //alert(code)
  axios.put(`${backApi}/secure/countries/${code}/status`,{
          code: code,
          status:  (status=='ACTIVE')?'INACTIVE':'ACTIVE'
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
      }       
      }).then((response) => {        
        router.go();        
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const storeCountry =()=>{
try {  
  schema.validateSync(formValues);
  axios.post(`${backApi}/secure/countries/new`,{
          countryCode:formValues.code,
          indicative:formValues.indicative,
          name:formValues.name,
          currency:formValues.currency
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 200){      
          router.go();  
        }      
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
} catch (error) {
        console.error(error);        
         errors.value="une erreur inattendue est apparue"
      
}

// name:name.value,
// email:email.value,
// contact:contact.value,
// description:description.value
}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}


onMounted(() => { 
  checkSessionValidate(1)
  getCountries();
   setTimeout(function () {
    pageLoad.value=true; 
         },1000)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[16] || (_cache[16] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: _ctx.$t('countries.search')
              }, null, 8, _hoisted_5), [
                [_vModelText, _unref(searchQuery)]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_unref(current_permissions)('create_country'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('countries.createCountry')) + " ", 1),
                    _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('countries.code')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('countries.countryCode')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('countries.name')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('countries.indicative')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('countries.currency')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('countries.status')), 1),
                    _cache[18] || (_cache[18] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedCountries), (country) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: country.id
                    }, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(country.code), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(country.countryCode), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(country.name), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(country.indicative), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(country.currency), 1),
                      _createElementVNode("td", _hoisted_22, [
                        (country.status==='ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('countries.active')), 1))
                          : _createCommentVNode("", true),
                        (country.status==='INACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('countries.inactive')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _cache[20] || (_cache[20] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_27, [
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('status_country'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (changeStatus(country.status,country.code))
                                  }, [
                                    _cache[19] || (_cache[19] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    (country.status==='ACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('countries.deactivate')), 1))
                                      : _createCommentVNode("", true),
                                    (country.status==='INACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('countries.activate')), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_28))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_unref(filteredTotal)>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (_unref(filteredTotal)>10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                        _createTextVNode(_toDisplayString(_ctx.$t('countries.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(page)*10), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('countries.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('countries.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(filteredTotal)<=10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                        _createTextVNode(_toDisplayString(_ctx.$t('countries.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('countries.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('countries.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_38, [
                    _createElementVNode("ul", _hoisted_39, [
                      ((_unref(page)-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPage)(_unref(page)-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[21] || (_cache[21] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numPages), (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==_unref(page))
                            ? (_openBlock(), _createElementBlock("a", _hoisted_41, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (_unref(goToPage)(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_42))
                        ]))
                      }), 128)),
                      ((_unref(page)+1)<=_unref(numPages))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPage)(_unref(page)+1))),
                              "aria-label": "Next"
                            }, [...(_cache[22] || (_cache[22] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(storeCountry, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("h1", _hoisted_48, _toDisplayString(_ctx.$t('countries.country')), 1),
              _cache[23] || (_cache[23] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_49, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("h6", _hoisted_51, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("h6", _hoisted_53, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('countries.countryCode')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValues.code) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['code'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('countries.countryCodePlaceholder'),
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (validate('code'))),
                        onKeyup: _cache[5] || (_cache[5] = ($event: any) => (validate('code')))
                      }, null, 42, _hoisted_58), [
                        [_vModelText, formValues.code]
                      ]),
                      _createElementVNode("span", _hoisted_59, _toDisplayString(errorsBis['code']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('countries.name')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('countries.namePlaceholder'),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (validate('name'))),
                        onKeyup: _cache[8] || (_cache[8] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_62), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_63, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t('countries.indicative')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formValues.indicative) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['indicative'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('countries.indicativePlaceholder'),
                        onBlur: _cache[10] || (_cache[10] = ($event: any) => (validate('indicative'))),
                        onKeyup: _cache[11] || (_cache[11] = ($event: any) => (validate('indicative'))),
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (validate('indicative')))
                      }, null, 42, _hoisted_67), [
                        [_vModelText, formValues.indicative]
                      ]),
                      _createElementVNode("span", _hoisted_68, _toDisplayString(errorsBis['indicative']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('countries.currency')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formValues.currency) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['currency'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('countries.currencyPlaceholder'),
                        onBlur: _cache[14] || (_cache[14] = ($event: any) => (validate('currency'))),
                        onKeyup: _cache[15] || (_cache[15] = ($event: any) => (validate('currency')))
                      }, null, 42, _hoisted_71), [
                        [_vModelText, formValues.currency]
                      ]),
                      _createElementVNode("span", _hoisted_72, _toDisplayString(errorsBis['currency']), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              (_unref(current_permissions)('create_country'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_74, [
                    _cache[24] || (_cache[24] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('countries.save')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}
}

})